import React, { useMemo, useState, useEffect } from 'react';
import Highcharts from 'highcharts';
import HC_more from 'highcharts/highcharts-more';
import HighchartsReact from 'highcharts-react-official';

HC_more(Highcharts);

export default function PieChart({ data = [], currentLevel, setSelectedGre, setSelectedSchool }) {
  const [screenWidth, setScreenWidth] = useState(typeof window !== 'undefined' ? window.innerWidth : 1200);

  useEffect(() => {
    const handleResize = () => setScreenWidth(window.innerWidth);
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  const options = useMemo(() => {
    const chartData = data.map(item => ({
      raw: item,
      name: item?.['regional_name'] || item?.['institution_name'],
      y: item?.['chart_percentage'],
      labelValue: item?.['chart_value'] || 0
    }));

    return {
      chart: {
        type: 'pie',
        backgroundColor: 'transparent'
      },
      credits: { enabled: false },
      title: { text: null },
      tooltip: {
        pointFormat: 'Percentual médio: <b>{point.labelValue}%</b>'
      },
      series: [
        {
          name: 'Funcionalidades',
          colorByPoint: true,
          data: chartData,
          innerSize: '40%'
        }
      ],
      plotOptions: {
        pie: {
          allowPointSelect: true,
          cursor: 'pointer',
          showInLegend: true,
          point: {
            events: {
              click: function () {
                if (currentLevel === 'gre') {
                  setSelectedGre(this.raw);
                } else if (currentLevel === 'schools') {
                  setSelectedSchool(this.raw);
                }
              },
              legendItemClick: function () {
                const item = this.raw;

                setTimeout(() => {
                  if (currentLevel === 'gre') {
                    setSelectedGre(item);
                  } else if (currentLevel === 'schools') {
                    setSelectedSchool(item);
                  }
                }, 0);

                return false;
              }
            }
          },
          dataLabels: {
            enabled: false,
            style: {
              fontWeight: 'bold',
              textOutline: 'none',
              fontSize: '11px',
              color: '#333'
            }
          }
        }
      },
      legend: {
        enabled: true,
        align: 'right',
        verticalAlign: 'middle',
        layout: 'horizontal',
        width: 600,
        itemWidth: 300,
        itemMarginBottom: 5
      },
      responsive: {
        rules: [
          {
            condition: { maxWidth: 768 },
            chartOptions: {
              chart: { marginBottom: 200 },
              legend: {
                align: 'center',
                verticalAlign: 'bottom',
                layout: 'vertical',
                width: 300,
                maxHeight: 160,
                marginTop: 20
              },
              plotOptions: {
                pie: {
                  dataLabels: {
                    distance: 10,
                    style: {
                      fontSize: '10px'
                    }
                  }
                }
              }
            }
          }
        ]
      }
    };
  }, [data, screenWidth]);

  return (
    <HighchartsReact
      highcharts={Highcharts}
      options={options}
    />
  );
}
